var map = {
	"./Ayurvedische_soesse.jpg": "ef6f",
	"./IMG_9343-removebg-preview (2).png": "6ce8",
	"./IMG_9343-removebg-preview (4).png": "0cf3",
	"./ayurvedischeSoesse.png": "d69c",
	"./ayurvedischeSoesse1.png": "2d77",
	"./background1.png": "881e",
	"./background2.png": "247d",
	"./background3.gif": "bc7d",
	"./background3.png": "456f",
	"./banana_lassi.jpg": "bff0",
	"./cart.svg": "0620",
	"./chicken_sekuwa.gif": "f1f5",
	"./chicken_sekuwa.png": "2d34",
	"./chicken_spies.png": "44c2",
	"./foodIcon.jpg": "d96e",
	"./foodiIcon.png": "d4f2",
	"./lassi_natur.jpeg": "0158",
	"./lassi_natur.jpg": "7a26",
	"./mang_lassi.jpg": "9e52",
	"./mang_lassi.png": "55e8",
	"./mango_lassi.png": "409b",
	"./namaste_nepal_logo.png": "06ba",
	"./nepali_momo.jpg": "381d",
	"./nepali_thali.gif": "c641",
	"./nepali_thali.jpeg": "0576",
	"./pencil.svg": "fa39",
	"./raita.png": "6b07",
	"./reis_salat.png": "002f",
	"./sekuwa_fleisch.gif": "7df5",
	"./sekuwa_fleisch.png": "64c5",
	"./spinat_curry1.png": "cb6f",
	"./spinat_curry2.png": "46fb",
	"./traditional-nepali-khana.jpg": "b302",
	"./veganfood.jpg": "08a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b50";